/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_Q2Inputs */

const en_dr_faq_q2 = /** @type {(inputs: Dr_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it really free for guests?`)
};

const id_dr_faq_q2 = /** @type {(inputs: Dr_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benar-benar gratis untuk peserta tamu?`)
};

/**
* | output |
* | --- |
* | "Is it really free for guests?" |
*
* @param {Dr_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_q2 = /** @type {((inputs?: Dr_Faq_Q2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_Q2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_q2(inputs)
	return en_dr_faq_q2(inputs)
});